/**
 * @generated SignedSource<<11c1ea367a9ae7e124cbd9675927a59e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedBuyItNowButton_viewer$data = {
  readonly buyNowAddToCheckout: boolean | null;
  readonly " $fragmentType": "PdpSharedBuyItNowButton_viewer";
};
export type PdpSharedBuyItNowButton_viewer$key = {
  readonly " $data"?: PdpSharedBuyItNowButton_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedBuyItNowButton_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedBuyItNowButton_viewer",
  "selections": [
    {
      "alias": "buyNowAddToCheckout",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "buyNowAddToCheckout"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"buyNowAddToCheckout\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "cf6f20d7f6214de6e1de011cd7f2df93";

export default node;
